import { event } from './EventEmitter';

// 显示登录弹窗
export function showLoginModal(isShow = true) {
  event.emit('event-showLoginModal', isShow);
}

// 显示绑定手机号弹窗
export function showBindPhoneModal(isShow = true, params = {}) {
  event.emit('event-showBindPhone', isShow, params);
}

// 显示邮箱弹窗
export function showBindEmailModal(isShow = true) {
  event.emit('event-showBindEmail', isShow);
}

// 显示修改密码弹窗
export function showSetPwdModal(isShow = true) {
  event.emit('event-showPwdModal', isShow);
}

// 显示其他设备登录文字
export function showOtherClientTip(isShow = true) {
  event.emit('event-showOtherClientStatus', isShow);
}

export { event };
